// extracted by mini-css-extract-plugin
module.exports = {"sizechart":"SizeChartModal_sizechart__v6w57","table":"SizeChartModal_table__LloU9","video":"SizeChartModal_video__dG7hz","body":"SizeChartModal_body__ylcBP"};